export default __webpack_public_path__ + "static/media/moon-active.821b2783.svg";